import React from 'react';
import { Link } from 'gatsby';

import Mark from './svg/Mark';
import Twitter from './social/Twitter';
import GitHub from './social/GitHub';
import LinkedIn from './social/LinkedIn';
import NewsletterSignUp from './NewsletterSignUp';
import Container from './Container';

const FooterNavLink = ({ href, label, ...otherProps }) => (
  <a className="text md:text-sm text-white nav-link pb-1" href={href} {...otherProps}>
    {label}
  </a>
);

const FooterNavItem = ({ children }) => <li className="mb-2 md:mb-0">{children}</li>;

const FooterNavLinkItem = ({ href, label, ...otherProps }) => (
  <FooterNavItem>
    <FooterNavLink href={href} label={label} {...otherProps} />
  </FooterNavItem>
);

const FooterNavMenu = ({ title, children }) => (
  <div className="w-[10rem] xl:w-[12rem] mb-9 md:mb-0">
    <span className="block mb-4 uppercase">{title}</span>
    <ul>{children}</ul>
  </div>
);

const FooterNavMenuGroup = ({ children, className }) => (
  <div className={`${className} grid grid-cols-2 md:grid-cols-3 content-evenly`}>{children}</div>
);

const FooterNavTop = ({ className }) => (
  <FooterNavMenuGroup className={className}>
    <FooterNavMenu title="Product">
      <FooterNavLinkItem href="/features" label="Features" />
      <FooterNavLinkItem href="/developers" label="For Developers" />
      <FooterNavLinkItem href="/integrations" label="Integrations" />
      <FooterNavLinkItem href="/payment-providers" label="Payment Providers" />
      <FooterNavLinkItem href="/adobe-commerce-subscriptions" label="Adobe Commerce" />
      <FooterNavLinkItem href="/salesforce-commerce-cloud-subscriptions" label="Salesforce Commerce" />
    </FooterNavMenu>

    <FooterNavMenu title="Company">
      <FooterNavLinkItem href="/about" label="About" />
      <FooterNavLinkItem href="/become-a-partner" label="Become a Partner" />
      <FooterNavLinkItem href="/contact" label="Contact" />
      <FooterNavLinkItem href="/careers" label="Careers" />
    </FooterNavMenu>

    <FooterNavMenu title="Support">
      <FooterNavLinkItem href="/support" label="Contact Support" />
      <FooterNavLinkItem
        aria-label="User Documentation (opens in new tab)"
        href="https://docs.subscribepro.com/"
        label="User Docs"
        target="_blank"
        rel="noopener noreferrer"
      />
      <FooterNavLinkItem
        href="https://status.subscribepro.com/"
        aria-label="System Status (opens in new tab)"
        label="System Status"
        target="_blank"
        rel="noopener noreferrer"
      />
    </FooterNavMenu>
  </FooterNavMenuGroup>
);

const FooterNavBottom = ({ className }) => (
  <FooterNavMenuGroup className={className}>
    <FooterNavMenu title="Legal">
      <FooterNavLinkItem href="/legal" label="Legal" />
      <FooterNavLinkItem href="/privacy-policy" label="Privacy Policy" />
      <FooterNavLinkItem href="/security-and-trust" label="Security & Trust" />
    </FooterNavMenu>

    <FooterNavMenu title="Resources">
      <FooterNavLinkItem href="/clients" label="Clients" />
      <FooterNavLinkItem href="/subscription-commerce-faq" label="FAQ" />
      <FooterNavLinkItem href="/blog" label="Blog" />
    </FooterNavMenu>

    {/* <FooterNavMenu title="By Platform">
      <FooterNavLinkItem href="/adobe-commerce-subscriptions" label="Adobe Commerce" />
      <FooterNavLinkItem href="/salesforce-commerce-cloud-subscriptions" label="Salesforce Commerce" />
    </FooterNavMenu> */}
  </FooterNavMenuGroup>
);

const Footer = () => (
  <footer className="bg-sp-primary-very-dark py-6 text-white font-bold">
    <Container>
      <div className="flex flex-col lg:flex-row mb-14 lg:mb-0 mt-5">
        <div className="w-full sm:max-w-[28rem] mb-14 mr-auto">
          <NewsletterSignUp className="mb-9 lg:mb-5" />

          <div className="flex items-center">
            <a
              aria-label="Subscribe Pro LinkedIn (opens in new tab)"
              href="https://www.linkedin.com/company/subscribe-pro/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedIn className="h-6 mr-4 fill-gray-200 hover:fill-white transition" />
            </a>
            <a
              aria-label="Subscribe Pro Twitter (opens in new tab)"
              href="https://twitter.com/subscribeprosw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter className="h-6 mr-4 fill-gray-200 hover:fill-white transition" />
            </a>
            <a
              aria-label="Subscribe Pro GitHub (opens in new tab)"
              href="https://github.com/subscribepro"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GitHub className="h-6 mr-4 fill-gray-200 hover:fill-white transition" />
            </a>
          </div>
        </div>
        <div className="max-w-[30rem] xl:max-w-[36rem]">
          <FooterNavTop className="md:mb-7" />
          <FooterNavBottom />
        </div>
      </div>
      <div>
        <Link to="/" className="inline-flex items-center" aria-label="Subscribe Pro Home">
          <Mark className="w-auto h-9 my-6" />
        </Link>
      </div>
      <div className="flex justify-between flex-col lg:flex-row text-white text-xs font-extralight">
        <p className="w-full sm:max-w-[28rem] mr-auto">Copyright 2014-2025 SUBSCRIBE PRO INC.</p>
        <p className="hidden lg:block w-[30rem] xl:w-[36rem]">
          Enthusiastically spreading the magic of The Subscription Math&trade; since 2014.
        </p>
      </div>
    </Container>
  </footer>
);

export default Footer;
